import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t, type IntlService } from 'ember-intl';
import { PhCurrencyDollar } from 'ember-phosphor-icons';
import HeroStat from 'tio-employee/components/dashboard-kit/hero-stat';
import type { ProgramPulse } from 'tio-employee/utils/partner-dashboard/sources/ta-analytics';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Hero tile: reimbursement paid across every application to date. */
export default class PaidToDateWidget extends Component<WidgetComponentSignature<ProgramPulse>> {
  @service declare intl: IntlService;

  get paid() {
    return this.intl.formatNumber(this.args.data.paidCents / 100, {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    });
  }

  <template>
    <HeroStat
      @emphasis="metric"
      @label={{t "partner_dashboard.pulse.paid"}}
      @value={{this.paid}}
      @context={{t "partner_dashboard.pulse.paid_context"}}
      @contextIcon={{PhCurrencyDollar}}
      data-test-partner-dashboard-paid-to-date
    />
  </template>
}
